import styled from 'styled-components';
import { Linha } from '../../styles/base';
import { bordaArredondar, espacamento } from '../../styles/constants/sizes';

export const PerguntaRespostaZeladoria = styled(Linha)`
  background-color: #f2f2f2;
  padding: ${espacamento.ultraPequeno}px;
  border-radius: ${bordaArredondar}px;
  overflow-wrap: anywhere;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
`;

export const PrintZeladoria = styled.div`
  height: 100vh;
  width: 100%;
  background-color: blue;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

`;

export const BotaoRps = styled.button`
font-size: 16px;
white-space: nowrap;
vertical-align: middle;
display: inline-block;
background: none;
border: none;
box-shadow: none;
cursor: pointer;
text-align: center;
font-weight: 500;
border-radius: 8px;
margin: 0;
outline: none;
margin-left: 2px;
width: 40px;
height: 40px;
border: 2px solid #eee;
transform: scale(1);
transition: background 0.2s ease-in, color 0.2s ease-in, border-color 0.2s ease-in, transform 0.2s cubic-bezier(0.5, 2, 0.5, 0.75);
`;
